module.exports = __webpack_public_path__ + "img/36.24b306a9.png";